import { useId } from '@react-aria/utils';
import * as React from 'react';

import * as Styled from './input-area.styles';
import type { InputAreaProps } from './input-area.types';

export const InputArea = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  InputAreaProps
>(
  (
    {
      className,
      id: providedId,
      label,
      multiline,
      onChange,
      placeholder,
      value,
      ...props
    },
    forwardedRef
  ) => {
    const generatedId = useId();
    const id = providedId || generatedId;
    const commonProps = {
      'data-xds': 'InputArea',
      id,
      placeholder,
      value,
    };

    if (multiline) {
      return (
        <Styled.Wrapper className={className}>
          {label && (
            <Styled.VisuallyHiddenLabel htmlFor={id}>
              {label}
            </Styled.VisuallyHiddenLabel>
          )}
          <Styled.Textarea
            {...commonProps}
            onChange={
              onChange as Extract<
                InputAreaProps,
                { multiline: true }
              >['onChange']
            }
            ref={forwardedRef as React.Ref<HTMLTextAreaElement>}
            {...(props as Extract<InputAreaProps, { multiline: true }>)}
          />
        </Styled.Wrapper>
      );
    }

    return (
      <Styled.Wrapper className={className}>
        {label && (
          <Styled.VisuallyHiddenLabel htmlFor={id}>
            {label}
          </Styled.VisuallyHiddenLabel>
        )}
        <Styled.Input
          {...commonProps}
          onChange={
            onChange as Exclude<InputAreaProps, { multiline: true }>['onChange']
          }
          ref={forwardedRef as React.Ref<HTMLInputElement>}
          {...(props as Exclude<InputAreaProps, { multiline: true }>)}
        />
      </Styled.Wrapper>
    );
  }
);

InputArea.displayName = 'InputArea';
